import React from 'react';
import { Box, Typography } from '@mui/material';
import TeacherScheduleOverview from './TeacherScheduleOverview';

// The weekly grid is the whole page; working hours are edited in-context
// via the pencil icon on each teacher's column (opens a drawer with
// TeacherScheduleForm scoped to that teacher).
export default function TeacherSchedule() {
    return (
        <Box>
            <Typography variant="h4" sx={{ mb: 3, textAlign: 'center', fontWeight: 'bold' }}>
                مدیریت برنامه کاری آموزگاران
            </Typography>
            <TeacherScheduleOverview />
        </Box>
    );
}
